import config from '@/common/config'
import { ModelApiService } from './BaseApiService'

export default class FormsApiService extends ModelApiService {
  constructor() {
    super(
      'submissions',
      `${config.get('forms2.api.url')}v${config.get('forms2.api.version')}/`,
      config.get('forms2.api.version')
    )
  }

  async getFormSubmissionAndSchemaByPasskey(passkey) {
    return await this.get(`${passkey}/full`)
  }

  async downloadFile(passkey, fileId) {
    return await this.getBlob(`${passkey}/files/${fileId}`)
  }
}
